import React, { useEffect, useState } from 'react'
import { Grid, Divider, TextField, Typography } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { useDebouncedCallback } from 'use-debounce'

import { Client, CustomField } from 'src/api/models'
import { useQueryPaginator } from 'src/components/Table'
import { FilterProps } from './types'

export const createCustomFieldFilter = (clientFetch: () => any, customFieldFetch: () => any) => {
  const CustomFieldFilter = (props: FilterProps) => {
    const { label, onChange, defaultValue } = props

    const [client, setClient] = useState<Client | null>(null)
    const [customField, setCustomField] = useState<CustomField | null>(null)
    const [value, setValue] = useState<string>('')
    const clientPaginator = useQueryPaginator(`${label}-client-filter`, clientFetch)
    const customFieldPaginator = useQueryPaginator(`${label}-custom_field-filter`, customFieldFetch)

    const deClientPaginatorFilters = useDebouncedCallback(clientPaginator.patchFilters, 100)
    const deCustomFieldPaginatorFilters = useDebouncedCallback(
      customFieldPaginator.patchFilters,
      100
    )

    useEffect(() => {
      if (defaultValue) {
        const { client, customField, value } = defaultValue
        setClient(client)
        setCustomField(customField)
        setValue(value)
      }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
      if (client && customField && value) {
        const newObjectValue = { client, customField, value }
        const newValue = `${customField.guid}:${value}`
        onChange(newObjectValue, newValue)
      }
    }, [client, customField, value]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
      <>
        <Typography variant="h6">{label}</Typography>
        <Divider />
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Autocomplete
              id={`${label}-client-filter`}
              options={clientPaginator.data.results}
              getOptionLabel={(client: Client) => client?.name || ''}
              getOptionSelected={(option, value) => option.guid === value?.guid}
              filterOptions={(option) => option}
              onChange={(event: any, newValue: any | null) => {
                setClient(newValue)
                setValue('')
                customFieldPaginator.patchFilters({ clients: newValue?.guid })
              }}
              value={client}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Client"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    deClientPaginatorFilters.callback({ search: event.target.value })
                  }
                />
              )}
            />
          </Grid>
          <Grid item xs={6}>
            <Autocomplete
              disabled={!client}
              id={`${label}-custom-field-filter`}
              options={customFieldPaginator.data.results}
              getOptionLabel={(obj: CustomField) => obj.label}
              getOptionSelected={(option, value) => option.guid === value?.guid}
              filterOptions={(option) => option}
              onChange={(event: any, newValue: any | null) => {
                setCustomField(newValue)
                setValue('')
              }}
              value={customField}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Custom Field"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    deCustomFieldPaginatorFilters.callback({ search: event.target.value })
                  }
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              disabled={!client || !customField}
              id={`${label}-value-filter`}
              variant="standard"
              multiline
              rows={4}
              label={customField?.label || 'Custom Field Values'}
              fullWidth
              value={value}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const newValue = e.target.value.replace(/\s+$/, '').replace(/\s/g, ',')
                setValue(newValue)
              }}
            />
            <Typography variant="caption">enter comma separated values</Typography>
          </Grid>
        </Grid>
      </>
    )
  }
  return CustomFieldFilter
}
